import { EventPhaseStatus } from "./event.model";

export interface PayloadEventsByStatus {
    pageNumber: number;
    pageSize: number;
    status: EventPhaseStatus;
}